import { BrandConfig } from './types';

export const mushystudioBrand: BrandConfig = {
  id: 'mushystudio',
  hosts: ['mushystudio.xyz', 'mushy.local'],
  title: 'Mushroom',
  siteName: 'Mushroom',
  description:
    'Mushroom is an AI-native media platform that transforms meme, creator, and character IP into motion-ready content, companion agents, and channel-based experiences.',
  canonicalOrigin: 'https://mushystudio.xyz',
  twitterSite: '',
  logoSrc: '/brands/mushystudio/logo.png',
  faviconHref: '/brands/mushystudio/favicon.svg',
  previewImageUrl: 'https://mushystudio.xyz/images/og.png',
  navItems: ['trade', 'LVUSD', 'LVMON', 'portfolio'],
  collateralTokenSymbols: ['MON', 'USDC', 'LVMON', 'LVUSD', 'Rona'],
  theme: {
    primary: '#FF8A1A',
    navBg: '#091109',
    pageBg: '#060B06',
    activeNav: '#FF8A1A',
  },
};